import type { ComponentProps } from 'react';
import { OwcBanner } from '@one/react';

export type PocBannerProps = ComponentProps<typeof OwcBanner>;

export const PocBanner: React.FC<PocBannerProps> = (props) => <OwcBanner {...props} />;
